
export const common = {
  nav: {
    home: 'Home',
    wms: {
      title: 'WMS Warehouse System',
      ecommerce: 'E-commerce Logistics WMS',
      thirdParty: 'Third-Party Logistics WMS'
    },
    ecommerce_wms: 'E-commerce WMS',
    logistics_wms: '3PL WMS',
    tms: 'TMS Transport System',
    about: 'About',
    contact: 'Contact Us',
    language: 'EN',
  },
  hero: {
    title: 'Smart Logistics Solutions',
    subtitle: 'Leading the Future of Warehouse Management & Transportation Systems',
    description: 'AUTOCHAIN provides advanced WMS and TMS systems to help businesses achieve intelligent logistics management, improve efficiency, and reduce costs.',
    cta: 'Get Started',
    cta1: 'Get Free Solution',
    cta2: 'Book Demo',
    demo: 'Book Demo',
  },
  painPoints: {
    title: 'Are You Facing These Logistics Challenges?',
    warehouse: {
      title: 'Warehouse Management Pain Points',
      pain1: 'Inaccurate inventory data, frequent stockouts or overstocking',
      pain2: 'Low manual operation efficiency, prone to errors',
      pain3: 'Unable to track goods location and status in real-time',
      pain4: 'Low warehouse space utilization, high costs',
    },
    transport: {
      title: 'Transportation Management Pain Points',
      pain1: 'Unable to track vehicle location and transport status in real-time',
      pain2: 'Unreasonable route planning increases transportation costs',
      pain3: 'Difficult driver management, complex salary calculations',
    },
    solution: '✅ AUTOCHAIN Smart Logistics System Solves All Pain Points!',
  },
  products: {
    title: 'Our Solutions',
    subtitle: 'Professional WMS and TMS systems providing comprehensive support for your logistics business',
    wms: {
      title: 'WMS Warehouse Management System',
      description: 'Intelligent warehouse management to improve inventory accuracy and operational efficiency',
      benefit: '✅ Improve warehouse efficiency by 40%, inventory accuracy up to 99.9%',
      cta: 'Learn About WMS',
    },
    tms: {
      title: 'TMS Transportation Management System',
      description: 'Optimize transportation routes, reduce logistics costs, and improve delivery efficiency',
      benefit: '✅ Save 30% transportation costs, improve customer satisfaction',
      cta: 'Learn About TMS',
    },
  },
  integration: {
    title: 'WMS + TMS Integration Power',
    effect: '1 + 1 > 2 Synergy Effect',
    description: 'When WMS and TMS systems are perfectly integrated, your logistics business will achieve unprecedented efficiency improvements. From order receipt to final delivery, every link can be seamlessly connected, creating greater business value for you.',
    steps: {
      step1: {
        title: 'Order Receipt',
        desc: 'Automatically receive and analyze orders',
      },
      step2: {
        title: 'WMS Processing',
        desc: 'Intelligent inventory allocation and picking',
      },
      step3: {
        title: 'TMS Dispatch',
        desc: 'Optimize routes and vehicle arrangements',
      },
      step4: {
        title: 'Customer Notification',
        desc: 'Real-time delivery status updates',
      },
    },
  },
  features: {
    title: 'Core Features',
    subtitle: 'Comprehensive Smart Logistics Management',
    wms: {
      title: 'WMS Warehouse Management System',
      description: 'Intelligent warehouse management to improve inventory accuracy and operational efficiency',
    },
    tms: {
      title: 'TMS Transportation Management System',
      description: 'Optimize transportation routes, reduce logistics costs, and improve delivery efficiency',
    },
    ai: {
      title: 'AI Smart Analytics',
      description: 'Utilize artificial intelligence to predict demand and optimize inventory allocation',
    },
  },
  benefits: {
    title: 'Why Choose AUTOCHAIN',
    subtitle: 'Professional Logistics Technology Solutions',
    efficiency: 'Improve Efficiency',
    efficiencyDesc: 'Automated processes reduce human errors and improve operational efficiency by 40%',
    cost: 'Reduce Costs',
    costDesc: 'Optimize inventory management and transportation routes, saving 30% operational costs',
    accuracy: 'Precise Management',
    accuracyDesc: 'Real-time tracking and data analysis with 99.9% inventory accuracy',
    support: 'Professional Support',
    supportDesc: '24/7 technical support ensuring stable system operation',
  },
  testimonials: {
    title: 'Customer Testimonials',
    subtitle: 'See what our customers say',
    customer1: {
      name: 'Manager Zhang',
      role: 'CaseTify Logistics Director',
      quote: 'After using AUTOCHAIN\'s WMS system, our inventory accuracy improved to 99.8%, greatly reducing stockout situations.',
    },
    customer2: {
      name: 'Director Li',
      role: 'Kee Wah Bakery Operations Director',
      quote: 'The TMS system helped us optimize delivery routes, reducing transportation costs by 25% and significantly improving customer satisfaction.',
    },
    customer3: {
      name: 'Manager Wang',
      role: 'San-Legend Global Warehouse Manager',
      quote: 'The integrated WMS+TMS solution made our logistics operations smoother, improving efficiency by 40%.',
    },
  },
  howItWorks: {
    title: 'How to Get Started',
    subtitle: 'Four simple steps to begin your smart logistics journey',
    step1: 'Needs Analysis',
    step1Desc: 'Our expert team thoroughly understands your business requirements',
    step2: 'Solution Design',
    step2Desc: 'Customize the most suitable logistics solution for you',
    step3: 'System Deployment',
    step3Desc: 'Rapid system deployment with comprehensive training support',
    step4: 'Continuous Optimization',
    step4Desc: 'Continuous monitoring and optimization to ensure optimal results',
    description: 'Our professional team will accompany you throughout the process, ensuring smooth system launch and maximum benefits.',
    cta: 'Get Started Now',
  },
  partners: {
    title: 'Trusted Partners',
    subtitle: 'Many renowned companies choose AUTOCHAIN',
  },
  finalCta: {
    title: 'Ready to Start Your Smart Logistics Journey?',
    description: 'Contact us now for professional logistics solution consultation and take your business to the next level.',
    requirements: 'We only need the following basic information:',
    req1: 'Contact Name',
    req2: 'Phone Number',
    req3: 'Company Name',
    contact: 'Or call directly: +852 9425 2903',
  },
  contactForm: {
    title: 'Contact Us',
    subtitle: 'Fill out the form and we will contact you within 24 hours',
    name: 'Name',
    namePlaceholder: 'Please enter your name',
    company: 'Company Name',
    companyPlaceholder: 'Please enter company name',
    email: 'Email',
    emailPlaceholder: 'Please enter email',
    phone: 'Phone',
    phonePlaceholder: 'Please enter phone number',
    message: 'Requirements Description',
    messagePlaceholder: 'Please describe your specific requirements...',
    submit: 'Submit Inquiry',
    submitSuccess: 'Submitted successfully! We will contact you within 24 hours.',
    submitError: 'Submission failed, please try again later or contact us directly.',
  },
  cta: {
    title: 'Ready to Start Your Smart Logistics Journey?',
    subtitle: 'Contact us now for professional logistics solution consultation',
    button: 'Free Consultation',
  },
  footer: {
    company: 'AUTOCHAIN TECHNOLOGY',
    description: 'Professional Smart Logistics Solutions Provider',
    quickLinks: 'Quick Links',
    contact: 'Contact Information',
    address: 'Kwun Tong, Kowloon, Hong Kong',
    phone: '+852 9425 2903',
    email: 'info@autochain.tech',
    copyright: '© 2024 AUTOCHAIN TECHNOLOGY. All rights reserved.',
  },
};
